import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=ea974488&"
import script from "./TeamList.vue?vue&type=script&lang=js&"
export * from "./TeamList.vue?vue&type=script&lang=js&"
import style0 from "./TeamList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports